import { useEffect, useRef } from 'react';

export const useShakeIntensity = () => {
  const shakeIntensityRef = useRef(1);

  const handleDeviceMotion = (event: DeviceMotionEvent) => {
    const acceleration = event.acceleration;
    if (!acceleration) return;
    const shakeIntensity =
      Math.abs(acceleration.x ?? 0) +
      Math.abs(acceleration.y ?? 0) +
      Math.abs(acceleration.z ?? 0);
    shakeIntensityRef.current = shakeIntensity;
  };

  useEffect(() => {
    window.addEventListener('devicemotion', handleDeviceMotion);

    return () => {
      window.removeEventListener('devicemotion', handleDeviceMotion);
    };
  }, []);

  return shakeIntensityRef;
};
